module.exports = __webpack_public_path__ + "static/3d-tour-b963e17ca75c7d4e5711e27b7a98da00.webp";